import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationModels } from '../../../../../models/configuration.models';
import { ApiServiceBase } from './api-service-base';

@Injectable({
  providedIn: 'root',
})
export class StatApiService extends ApiServiceBase {
  constructor(
    config: ConfigurationModels.Configuration,
    httpClient: HttpClient,
  ) {
    super(config, httpClient, 'stats');
  }

  getPoliciesByDay() {
    return this.getJson('/policiesByDay');
  }

  getAgenciesByDay() {
    return this.getJson('/agenciesByDay');
  }

  getMoneyPerMonth() {
    return this.getJson('/moneyPerMonth');
  }

  getPackages() {
    return this.getJson('/packages');
  }

  getAgencyStates() {
    return this.getJson('/agencyStates');
  }

  getPolicyStates() {
    return this.getJson('/policyStates');
  }

  getPolicyByInsuranceTypes() {
    return this.getJson('/policyByInsuranceType');
  }

  getEmailStatByDate() {
    return this.getJson('/emailByDate');
  }
}
